import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { DocumentFileTemplateKeyKindEnum } from '@zaoblako/shared/modules/catalog/enums/document-file-template-key-kind.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized labels for {@link DocumentFileTemplateKeyKindEnum} */
export const DocumentFileTemplateKeyKindEnumI18n: EnumI18nInterface<DocumentFileTemplateKeyKindEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [DocumentFileTemplateKeyKindEnum.ORDINARY]: 'Обычный',
    [DocumentFileTemplateKeyKindEnum.AMOUNT_IN_WORDS]: 'Сумма прописью',
  },
  [I18nLocalesEnum.EN_US]: {
    [DocumentFileTemplateKeyKindEnum.ORDINARY]: 'Ordinary',
    [DocumentFileTemplateKeyKindEnum.AMOUNT_IN_WORDS]: 'Amount in words',
  },
};
